import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import NoData from './NoData'
import Token from './Token'

const useStyles = makeStyles(() => ({
  summaryContainer: {
    padding: 'var(--padding-xs) var(--padding-sm)',
    borderRadius: 'var(--border-radius-sm)',
    border: 'var(--border-neutral-thin)'
  },
  summaryTable: {
    padding: 'var(--padding-xs) var(--padding-sm)',
    borderRadius: 'var(--border-radius-sm)',
    border: 'var(--border-neutral-thin)',
    width: '100%',
    borderCollapse: 'collapse'
  },
  tableHeader: {
    backgroundColor: 'var(--tc-table-header-bg-color)'
  }
}))

function SummaryField ({ filterId, summary }) {
  const classes = useStyles()

  if (!summary) {
    return (
      <div className={classes.summaryContainer}>
        <NoData message='No Summary' />
      </div>
    )
  }

  return (
    <table className={classes.summaryTable}>
      <thead className='text-left'>
        <tr className={classes.tableHeader}>
          <th>Column</th>
          <th>Op</th>
          <th>As</th>
          <th>Accessor</th>
        </tr>
      </thead>
      <tbody>
        {summary.map(item => (
          <tr key={item.as}>
            <td>{item.column}</td>
            <td>{item.op}</td>
            <td>{item.as}</td>
            <td className='py-2 px-0'>
              <Token>{`${filterId}.metrics.${item.as || item.op}`}</Token>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

SummaryField.propTypes = {
  filterId: PropTypes.string,
  summary: PropTypes.object
}

export default SummaryField
